import { GenericObject } from "@eave/shared/types/application";

interface BasicAddress {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  zip: string;
}

// HomeLight address
export const SFAddress: BasicAddress = {
  line1: "100 California Street",
  line2: "Suite 800",
  city: "San Francisco",
  state: "CA",
  zip: "94111",
};

export const AZAddress: BasicAddress = {
  line1: "1375 N. Scottsdale Rd.",
  line2: "Suite 140",
  city: "Scottsdale",
  state: "AZ",
  zip: "85257",
};

// This address was added with story #87223, and as stated matches exactly what's given.
// As of the writing of this, only used in the footer.
export const CompliantAZAddress: BasicAddress = {
  line1: "1375 N. Scottsdale Rd.",
  line2: "# 110",
  city: "Scottsdale",
  state: "AZ",
  zip: "85257",
};

export const FlagstarAddress: BasicAddress = {
  line1: "5151 Corporate Drive",
  line2: "",
  city: "Troy",
  state: "MI",
  zip: "48098",
};
/** Stringifies an address object. Only use for basic, known addresses like company addresses.
 * @param  {BasicAddress} a An object of type BasicAddress
 * @returns string A stringified address
 */
export const addressObjToString = (a: BasicAddress): string => {
  if (a.line2) {
    // "1375 N. Scottsdale Rd. Suite 140, Scottsdale, AZ 85257"
    return `${a.line1} ${a.line2}, ${a.city}, ${a.state} ${a.zip}`;
  }

  // "1375 N. Scottsdale Rd., Scottsdale, AZ 85257"
  return `${a.line1}, ${a.city}, ${a.state} ${a.zip}`;
};
/** formatAddress
 * @param  {string} line1 The first line of the address
 * @param  {string=""} line2 The second line of the address, defaults to empty string
 * @param  {string} city The city of the address
 * @param  {string} state The state of the address
 * @param  {string} zip The zip code of the address (5 or 9 digits)
 * @returns string
 */
export const formatAddress = (
  line1: string,
  line2: string = "",
  city: string,
  state: string,
  zip: string,
): string | null => {
  // If no address data is provided, return empty string
  if (!line1 && !line2 && !city && !state && !zip) {
    return "";
  }

  if (!line1 || !city || !state || !zip) {
    console.warn("Missing address information");
    return "";
  }

  if (line2) {
    // "1375 N. Scottsdale Rd. Suite 140, Scottsdale, AZ 85257"
    return `${line1} ${line2}, ${city}, ${state} ${zip}`;
  }

  // "1375 N. Scottsdale Rd., Scottsdale, AZ 85257"
  return `${line1}, ${city}, ${state} ${zip}`;
};

export const SFAddressFormatted = addressObjToString(SFAddress);
export const AZAddressFormatted = addressObjToString(AZAddress);
export const FlagstarAddressFormatted = addressObjToString(FlagstarAddress);

export const email: GenericObject = {
  support: "HLHLsupport@homelight.com",
  terms: "HLHLterms@homelight.com",
  privacy: "HLHLprivacy@homelight.com",
  complaint: "HLHLcomplaint@homelight.com",
  inquiries: "HLHLinquiries@homelight.com",
};

export const phone: GenericObject = {
  display: "844-882-3283",
  number: "+1-844-882-3283",
};

export const fax: string = "844-883-3283";

export const eaveLegalName = {
  informal: "HomeLight Home Loans",
  formal:
    "HomeLight Home Loans, Inc. d/b/a HomeLight Home Loans, HomeLight Mortgage, Inc and Accept.inc.",
};
